import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {ActivatedRoute} from "@angular/router";
import {NgxSpinnerService} from "ngx-spinner";
import {AssignmentService} from "../../services/assignment.service";
import {BaseModel} from "../../models/BaseModel";
import {AssignmentDetail} from "../../models/assignment/assignment";
import {concatMap, take, takeWhile, timer} from "rxjs";
import {tap} from "rxjs/operators";
import swal from "sweetalert2";
import {ApplicationFileInfo} from "../../models/grantApplication/grantApplicationResponse";
import Swal from "sweetalert2";


@Component({
  selector: 'app-external-active-assitnment-detail',
  templateUrl: './external-active-assitnment-detail.component.html',
  styleUrls: ['./external-active-assitnment-detail.component.scss']
})
export class ExternalActiveAssitnmentDetailComponent implements OnInit {

  @ViewChild('signDocumentTemplate', {static: true}) signDocumentTemplate!: TemplateRef<any>;
  @ViewChild('downloadDocumentTemplate', {static: true}) downloadDocumentTemplate!: TemplateRef<any>;
  @ViewChild('rejectedDocumentTemplate', {static :true}) rejectedDocumentTemplate!: TemplateRef<any>;
  @ViewChild('loadingDocumentTemplate', {static :true}) loadingDocumentTemplate!: TemplateRef<any>;
  @ViewChild('SignedTemplate', {static :true}) signedTemplate!: TemplateRef<any>;

  id: string = "";
  contractForm: FormGroup = new FormGroup({
    id: new FormControl(''),
    projectId: new FormControl(''),
    dateRange: new FormControl({value: '', disabled: true}),
    jobDescription: new FormControl({value: '', disabled: true}),
    workingHour: new FormControl({value: '', disabled: true}),
    terminationOfContract: new FormControl({value: '', disabled: true}),
    honorarium: new FormControl({value: '', disabled: true}),
    honorariumToBePaid: new FormControl({value: '', disabled: true}),
    coverageOfExpenses: new FormControl({value: '', disabled: true}),
  });
  protected assigmentDetail: AssignmentDetail | undefined;
  protected docStatus: 1 | 2 | 0 | undefined = undefined;
  protected SignUrl: string | undefined;
  loadDocStatus: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private assignmentService: AssignmentService,
  ) {
    this.route.params.subscribe(params => {
      this.id = params['id'];
      this.contractForm.get('projectId')?.setValue(this.id);
    });
  }

  getButtonTemplate(assigmentDetail: AssignmentDetail | undefined): TemplateRef<any> | null {

    if(this.loadDocStatus){
      return this.loadingDocumentTemplate;
    }

    if (assigmentDetail?.isAssignmentSigned) {
      return this.downloadDocumentTemplate;
    }

    if (this.docStatus === 2) {
      return this.rejectedDocumentTemplate;
    }

    if (this.docStatus === 1) {
      return this.signedTemplate;
    }

    if (this.assigmentDetail?.statusName === 'AwaitingSignatures'){

      return this.signDocumentTemplate;

    }








    return null;
  }

  private getCookie(name: string): string | null {
    const cookieArr = document.cookie.split(';');
    for (const cookie of cookieArr) {
      const [cookieName, cookieValue] = cookie.trim().split('=');
      if (cookieName === name) {
        return decodeURIComponent(cookieValue);
      }
    }
    return null;
  }

  async ngOnInit(): Promise<void> {


    await this.spinner.show();
    Promise.all([
      this.loadActiveAssignment(this.id),
    ]).then(() => {
    }).finally(
      () => {
        this.spinner.hide()

        const result = document.referrer.includes('verified');

        if (result) {

          const sidValue = this.getCookie(this.sidCookiesName);
          if ( sidValue) {

            this.loadFWAStatus(sidValue);

          }

        }
      }
    );

  }

  loadAssignmentDetail(id: string): Promise<AssignmentDetail | undefined> {

    return new Promise((resolve, reject) => {

      this.assignmentService.getInfo(id).subscribe(
        async (data: BaseModel<AssignmentDetail>) => {
          await this.spinner.hide();

          if (!data.result) {
            reject(data.messages?.join(' ') || 'An unexpected error occurred. Please try again.');
          } else {
            resolve(data.item);
          }
        },
        async error => {

          reject(error);
          await this.spinner.hide();
          console.error('Error fetching assignment detail:', error);
        }
      );
    })
  }

  onSubmit() {

  }




  loadFWAStatus(sidValue: string | undefined): void {
    if (!sidValue) {
      return;
    }

    const polling$ = timer(0, 5000).pipe(
      concatMap(() => this.assignmentService.getDocsStatus(sidValue)),
      tap(response => {
        this.docStatus = response.item?.signedStatus;
      }),
      takeWhile(() => this.docStatus === undefined && this.docStatus === 0, true),
      take(10)
    );

    polling$.subscribe({
      next: () => {
        console.log('Polling iteration complete. docStatus:', this.docStatus);
      },
      error: err => {
        console.error('Polling error:', err);
      },
      complete: () => {
        console.log('Polling stopped (docStatus is 1 or 2).');
      },
    });
  }

  private async loadActiveAssignment(id: string): Promise<boolean> {

    try {
      const result = await this.loadAssignmentDetail(id);

      this.assigmentDetail = result;

      const startDateObj = result?.fromDate ? new Date(result.fromDate) : undefined;
      const endDateObj = result?.toDate ? new Date(result.toDate) : undefined;

      this.contractForm.patchValue({
        id: result?.id,
        dateRange: [startDateObj, endDateObj],
        jobDescription: result?.jobDescription,
        workingHour: result?.workingHours,
        terminationOfContract: result?.terminationofcontact,
        honorarium: result?.honorarium,
        honorariumToBePaid: result?.honorariumtobepaid,
        coverageOfExpenses: result?.coverageofexpenses,
        projectId: result?.projectDetail?.projectId,
      });


      return Promise.resolve(true);

    } catch (e) {
      console.error(e);
      return Promise.reject(e);
    }


  }

  private setCookie(name: string, value: string, days: number): void {
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/`;
  }

  private sidCookiesName = 'sidValue';

  async redirectToSignUrl() {

    const currentUrl = window.location.href;

    this.loadDocStatus = true;

    await this.spinner.show();
    this.assignmentService.Generatefwalink({
      assignmentId: this.assigmentDetail?.id || '',
      redirectUrl: currentUrl
    }).subscribe({
      next: async res => {
        if (res.item) {
          if (res.item.signingLink) {

            this.SignUrl = res.item.signingLink;

            const match = res.item.signingLink.match(/sid%3D(.*?)&/);

            if (match && match[1]) {
              const sidValue = match[1];


              this.setCookie(this.sidCookiesName, sidValue, 1);


              console.log(sidValue);

              window.location.href = this.SignUrl;

            } else {
              console.log("No matching value found");
            }
          }
        }
      },
      complete: async () => {
        this.spinner.hide();
        this.loadDocStatus = false;

        if (!this.SignUrl) {
          await swal.fire({
            title: 'Signing document',
            text: 'This contract does not have a document for signing.',
            icon: 'error',
          });
        }
      }
    });



  }

  async downloadFSA() {
    await this.spinner.show();
    this.assignmentService.getSignedDocuments(this.assigmentDetail?.id).pipe(
      concatMap((value) => {

        console.log('PSA file name fetched successfully:', value);

        const fileId = value.item?.fileId || '';

        if (!fileId) {
          throw new Error('File ID is missing or invalid.');
        }
        return this.assignmentService.downloadFwaFile(fileId);
      })
    ).subscribe({
      next: (async (fileInfo: BaseModel<ApplicationFileInfo>) => {

        if (fileInfo) {
          let base64Data = fileInfo.item?.documentBody ?? "";
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], {type: fileInfo.item?.mimeType});
          await this.spinner.hide();
          // Create download URL
          const url = window.URL.createObjectURL(blob);
          //this.downloadUrl = this.sanitizer.bypassSecurityTrustUrl(url);
          if (url) {
            const link = document.createElement('a');
            link.href = url;
            link.download = fileInfo.item?.fileName || 'downloaded-file'; // Use the document name if available
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        } else {
          await this.spinner.hide();
        }
      }),
      error: async (error) => {
        // Reported by HttpErrorInterceptor, which has the readable text and the reference id.
        console.error('Error in chained API calls:', error);
      },
      complete: async () => {
        console.log('Finished chained API calls.');
        await this.spinner.hide();
      }
    });
  }


}
